import React from "react";
import DocumentationSidebar from "../component/DocumentationSidebar";
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function RecommendationViaCustomVariable() {
  const { t } = useTranslation();
  const image014 = useDocImage('qanda-builder-img', 'image0014.png');
  const image015 = useDocImage('qanda-builder-img', 'image0015.png');
  const image016 = useDocImage('qanda-builder-img', 'image0016.png');
  const image017 = useDocImage('qanda-builder-img', 'image0017.png');
  const image018 = useDocImage('qanda-builder-img', 'image0018.png');
  const image019 = useDocImage('qanda-builder-img', 'image0019.png');
  const image020 = useDocImage('variables-img', 'image016.png');
  const image021 = useDocImage('qanda-builder-img', 'image0021.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        {/* Page Content */}
        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.recommendations.title')}</h1>

{/* 0. Overview */}
<div className="card dashboard-card mb-4">
  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
    {t('documentation.recommendations.overview.title')}
  </div>
  <div className="card-body">
    <p>{t('documentation.recommendations.overview.intro1')}</p>


<p className="mb-2">
  {t('documentation.recommendations.overview.intro2')}
</p>

<div className="bg-light rounded border p-3 mb-3">
  <div className="mb-1"><b>{t('documentation.recommendations.overview.exampleTitle')}</b></div>
  <p className="mb-2">
    {t('documentation.recommendations.overview.exampleIntro')}
  </p>
  <ul className="mb-2">
    <li>{t('documentation.recommendations.overview.exampleOptions.optionA')}</li>
    <li>{t('documentation.recommendations.overview.exampleOptions.optionB')}</li>
    <li>{t('documentation.recommendations.overview.exampleOptions.optionC')}</li>
  </ul>

  <p className="mb-1"><b>{t('documentation.recommendations.overview.variableName')}</b></p>
  <p className="mb-2">{t('documentation.recommendations.overview.linkText')}</p>

</div>

  </div>
</div>


{/* 1. Create Variables */}
<div className="card dashboard-card mb-4">
  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
    {t('documentation.recommendations.createVariables.title')}
  </div>
  <div className="card-body">
    <p>{t('documentation.recommendations.createVariables.intro')}</p>

    <ol className="mb-0">
       <img src={image014} alt="Edit Custom variable" className=' pt-10 pb-30' />
      <li className="mb-2">
        {t('documentation.recommendations.createVariables.steps.step1')}
      </li>

      <li className="mb-2">
        {t('documentation.recommendations.createVariables.steps.step2Title')}
        <ul>
          <li>
            {t('documentation.recommendations.createVariables.steps.fields.label')}
          </li>
          <li>
            {t('documentation.recommendations.createVariables.steps.fields.type')}
          </li>
          <li>
            {t('documentation.recommendations.createVariables.steps.fields.variableName')}
          </li>
          <li>
            {t('documentation.recommendations.createVariables.steps.fields.description')}
          </li>
        </ul>
      </li>

      <li className="mb-2">
        {t('documentation.recommendations.createVariables.steps.step3')}
      </li>

    </ol>
  </div>
</div>



           {/* 2. Link at Option Level */}
<div className="card dashboard-card mb-4">
  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
   {t('documentation.recommendations.linkOptions.title')}
  </div>
  <div className="card-body">
    <p>{t('documentation.recommendations.linkOptions.intro')}</p>

    <ol>
      <li className="mb-2">
        {t('documentation.recommendations.linkOptions.steps.step1')}
      </li>

      <li className="mb-2">
        {t('documentation.recommendations.linkOptions.steps.step2')}
      </li>

      <li className="mb-2">
        {t('documentation.recommendations.linkOptions.steps.step3')}
      </li>
       <img src={image015} alt="Edit Custom variable" className=' pt-10 pb-30' />

      <li className="mb-2">
        {t('documentation.recommendations.linkOptions.steps.step4Title')}
        <ul>
            <img src={image017} alt="Edit Custom variable" className=' pt-10 pb-30' /><br></br>
            <img src={image016} alt="Edit Custom variable" className=' pt-10 pb-30' />
          <li>
            {t('documentation.recommendations.linkOptions.steps.step4Items.selectVariable')}
          </li>
          <li>
            {t('documentation.recommendations.linkOptions.steps.step4Items.enterValue')}
          </li>
        </ul>
      </li>

      <li className="mb-2">
        {t('documentation.recommendations.linkOptions.steps.step5')}
      </li>
<li className="mb-2">
 {t('documentation.recommendations.linkOptions.steps.reuseTitle')}
  
  <div className="pt-10 pb-20">
    <img src={image018} alt="Reuse same variable on another option" className=' pt-10 pb-30' />
    <ul className="mt-2">
    <li>{t('documentation.recommendations.linkOptions.steps.reuseItems.item1')}</li> 
    <li>{t('documentation.recommendations.linkOptions.steps.reuseItems.item2')}</li>
  </ul>
    <img src={image019} alt="Reuse same variable on another option" className=' pt-10 pb-30' />
   
  </div>
</li>

     
    </ol>

    
  </div>
</div>













<div className="card dashboard-card mb-4">
  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
    {t('documentation.recommendations.stageRecommendations.title')}
  </div>
  <div className="card-body">
    <p>{t('documentation.recommendations.stageRecommendations.intro')}</p>

    <p><b>{t('documentation.recommendations.stageRecommendations.howToTitle')}</b></p>
    <ol>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step1')}
        <img src={image020} alt="Add Stage" className="pt-10 pb-30" />
      </li>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step2')}
      </li>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step3')}
      </li>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step4')}
      </li>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step5Title')}
        <ul>
          <li>{t('documentation.recommendations.stageRecommendations.steps.step5Items.item1')}</li>
          <li>{t('documentation.recommendations.stageRecommendations.steps.step5Items.item2')}</li>
          <li>{t('documentation.recommendations.stageRecommendations.steps.step5Items.item3')}</li>
          <li>{t('documentation.recommendations.stageRecommendations.steps.step5Items.item4')}</li>
        </ul>
      </li>
      <li>
        {t('documentation.recommendations.stageRecommendations.steps.step6')}
      </li>
    </ol>

    <p><b>{t('documentation.recommendations.stageRecommendations.editTitle')}</b></p>
    <ul>
      <li>{t('documentation.recommendations.stageRecommendations.editItems.item1')}</li>
      <img src={image021} alt="Variables in Stage" className="pt-10 pb-30" />

      <li>{t('documentation.recommendations.stageRecommendations.editItems.item2')}</li>
      <li>{t('documentation.recommendations.stageRecommendations.editItems.item3')}</li>
      <li>{t('documentation.recommendations.stageRecommendations.editItems.item4')}</li>
    </ul>

    <p><b>{t('documentation.recommendations.stageRecommendations.deleteTitle')}</b></p>
    <ul>
      <li>{t('documentation.recommendations.stageRecommendations.deleteItems.item1')}</li>
      <li>{t('documentation.recommendations.stageRecommendations.deleteItems.item2')}</li>
    </ul>

    <p className="mb-0">
      {t('documentation.recommendations.stageRecommendations.conclusion')}
    </p>
  </div>
</div>












            {/* 3. Render in Report */}
           
          </div>
        </div>
      </div>
    </div>
  );
}
